/*! License details at fancyapps.com/license */
var s = function s(_s) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var c = arguments.length > 2 ? arguments[2] : undefined;
  _s && _s.classList && t.split(" ").forEach(function (t) {
    t && _s.classList.toggle(t, c || !1);
  });
};
export { s as toggleClass };